import { Module } from 'vuex'
import getters from '@/store/share/getters'
import actions from '@/store/share/actions'
import mutations from '@/store/share/mutations'
import { ShareState } from '@/store/share/types'
import { RootState } from '@/store/types'

const state: ShareState = {
    /**
     * All users
     */
    users: [],

    /**
     * Peers with access to the current entry
     */
    peers: [],

    /**
     * New peer data
     */
    newPeer: {
        peer: undefined,
        permission: undefined
    }
}

const share: Module<ShareState, RootState> = {
    state,
    getters,
    actions,
    mutations
}

export default share
